<template>
<div>

<div v-show="msg.title">

  <div v-bind:class="activeClass[msg.type]" role="alert">
     <!--
     <h4 class="alert-heading">
       <i class="mr-2" v-bind:class="iconClass[msg.type]" aria-hidden="true"></i>
       {{msg.title}}
     </h4>
    <p>
    <strong>{{msg.body}}</strong>  
    </p>
    -->
    <i class="mr-2" v-bind:class="iconClass[msg.type]" aria-hidden="true"></i> 
   <strong>{{msg.title}} </strong>{{msg.body}}
    <button @click="$emit('close')" type="button" class="close" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

</div>

</div>
</template>
<script>

export default {
  props  : ['msg'],
  data () 
  {
    return {
      activeClass :['alert alert-success alert-dismissible show','alert alert-danger alert-dismissible show'],  
      iconClass:['fas fa-check','fas fa-exclamation-triangle']
    }
    
    },
  computed : {
    

     },
   created () 
    {
      
     
     
    },
  methods: {
    
  }
}
</script>

<style scoped>
.alert-danger
{
  background-color:#cd5252;
  color : white
}
</style>
